import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4964e7fa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=4964e7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964e7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4964e7fa')) {
      api.createRecord('4964e7fa', component.options)
    } else {
      api.reload('4964e7fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4964e7fa&scoped=true&", function () {
      api.rerender('4964e7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/Hamburger/index.vue"
export default component.exports